<template>
  <div class="alls">
    <!-- 头部 -->
    <b-container class=" bv-example-row">
      <b-row>
        <b-col cols="12">
          <div class="title mt-6">
            <div class="title-text">Understand the process</div>
            <div class="title-name">你需要了解的雅思流程!</div>
            <div class="title-welcome">
              <span>雅思专业服务</span>
              <span>SERVICES</span>
            </div>
          </div>
        </b-col>
      </b-row>
      <!-- 列表 -->
      <b-row align-h="center">
        <b-col class="subject" cols="12" md="5" lg="5" xl="5">
          <img :src="$store.state.url + 'ielts-bg1.png'" alt="" />
          <img class="cet-logo" src="../../images/cet-logo.png" alt="" />
        </b-col>
        <b-col class="subject" cols="12" md="5" lg="5" xl="5">
          <img src="../../images/cet-bg.png" alt="" />
          <div class="subject-content">
            <div>督学体验课</div>
            <div>一</div>
            <div>购买即日起督学任务开始生效</div>
            <div class="subject-price">
              <span>
                <span style="font-size: 16px;">¥</span>
                69.00
              </span>
              <span>原价¥825.00</span>
            </div>
            <div class="go-detail" @click="gocoursedetails(0)">
              查看详情
              <span class="gt"><img src="../../images/gt.svg" alt="" /></span>
            </div>
          </div>
        </b-col>
      </b-row>
      <!-- 列表 -->
      <b-row align-h="center">
        <b-col class="subject" cols="12" md="5" lg="5" xl="5">
          <img :src="$store.state.url + 'ielts-bg2.png'" alt="" />
          <img class="cet-logo" src="../../images/cet-logo.png" alt="" />
        </b-col>
        <b-col class="subject" cols="12" md="5" lg="5" xl="5">
          <img src="../../images/cet-bg.png" alt="" />
          <div class="subject-content">
            <div>雅思1对1每日微课</div>
            <div>一</div>
            <div>限时用劵立减，赠送雅思大礼包</div>
            <div class="subject-price">
              <span>
                <span style="font-size: 16px;">¥</span>
                2200.00-9100.00
              </span>
              <!-- s -->
            </div>
            <div class="go-detail" @click="gocoursedetails(1)">
              查看详情
              <span class="gt"><img src="../../images/gt.svg" alt="" /></span>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row align-h="center">
        <b-col class="subject" cols="12" md="5" lg="5" xl="5">
          <img :src="$store.state.url + 'ielts-bg3.png'" alt="" />
          <img class="cet-logo" src="../../images/cet-logo.png" alt="" />
        </b-col>
        <b-col class="subject" cols="12" md="5" lg="5" xl="5">
          <img src="../../images/cet-bg.png" alt="" />
          <div class="subject-content">
            <div>雅思精品特训班</div>
            <div>一</div>
            <div>限时用劵立减，赠送雅思大礼包</div>
            <div class="subject-price">
              <span>
                <span style="font-size: 16px;">¥</span>
                8888.00
              </span>
              <span>原价¥12800.00</span>
            </div>
            <div class="go-detail" @click="gocoursedetails(2)">
              查看详情
              <span class="gt"><img src="../../images/gt.svg" alt="" /></span>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row align-h="center">
        <b-col class="subject" cols="12" md="5" lg="5" xl="5">
          <img :src="$store.state.url + 'ielts-bg4.png'" alt="" />
          <img class="cet-logo" src="../../images/cet-logo.png" alt="" />
        </b-col>
        <b-col class="subject" cols="12" md="5" lg="5" xl="5">
          <img src="../../images/cet-bg.png" alt="" />
          <div class="subject-content">
            <div>雅思1对1提分宝</div>
            <div>一</div>
            <div>限时用劵立减，赠送雅思大礼包</div>
            <div class="subject-price">
              <span>
                <span style="font-size: 16px;">¥</span>
                19900.00
              </span>
              <span>原价¥28800.00</span>
            </div>
            <div class="go-detail" @click="gocoursedetails(3)">
              查看详情
              <span class="gt"><img src="../../images/gt.svg" alt="" /></span>
            </div>
          </div>
        </b-col>
      </b-row>
      <!-- 咨询 -->
      <b-row>
        <b-col cols="12">
          <div class="title consulting mt-6">
            <div class="title-text">You need to ask us?</div>
            <div class="title-name">你需要问我们什么？</div>
            <div class="title-welcome">
              <span>雅思咨询</span>
              <span>CONSULTING</span>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row align-h="center" class="list">
        <b-col cols="12" md="10" lg="10" xl="10" class="consulting-list">
          <div class="qa">Q/A</div>
          <!-- 咨询列表 -->
          <b-row class="list-content">
            <b-col cols="12" md="5" lg="5" xl="5" class="d1"><img src="https://honeybee-cn.oss-cn-beijing.aliyuncs.com/images/ielts-consulting1.png" alt="" /></b-col>
            <b-col cols="12" md="5" lg="7" xl="7" class="d2">
              <div class="listcontent-top">
                <div class="listcontent-left">
                  <img src="../../images/true.png" alt="" />
                  <span>【雅思必备】99个最牛介词词组-所有的介词用法</span>
                </div>
                <div class="look-detail">
                  <a href="https://mp.weixin.qq.com/s/4v52aMCTMLpE07ktGessGw" target="_blank">
                    <span>查看详情</span>
                    <img src="../../images/backgt.png" alt="" />
                  </a>
                </div>
              </div>
              <div class="l-detail">
                介词是很多同学不太会使用的一种词性，因为介词非常万能，和不同的词汇搭配会产生不同的意思。
                <br />
                更重要的是，介词在雅思口语考试和雅思写作考试中非常重要，尤其是介词词组，这也是雅思的词汇评分标准之一。
              </div>
            </b-col>
          </b-row>
          <!-- 咨询列表 -->
          <b-row class="list-content">
            <b-col cols="12" md="5" lg="5" xl="5" class="d1"><img src="https://honeybee-cn.oss-cn-beijing.aliyuncs.com/images/ielts-consulting2.png" alt="" /></b-col>
            <b-col cols="12" md="5" lg="7" xl="7" class="d2">
              <div class="listcontent-top">
                <div class="listcontent-left">
                  <img src="../../images/true.png" alt="" />
                  <span>雅思7分速成？你想要的捷径这篇文案里面没有</span>
                </div>
                <div class="look-detail">
                  <a href="https://mp.weixin.qq.com/s/aD6ma9T6z-bCXvNIXfnLzw" target="_blank">
                    <span>查看详情</span>
                    <img src="../../images/backgt.png" alt="" />
                  </a>
                </div>
              </div>
              <div class="l-detail">
                一个月，雅思口语从5.5到8!总分从6到7！备考一个月首战7.5! 40天，雅思5.5飞跃到7分！
                看到这些“标题”瞬间热血沸腾，肾上腺素飙升全新的希望又被重新点燃。但是又有多少人去实践了？
                嗡嗡君敢肯定，大多数人即使去实践了，也不一定会有这样的收获。因为我们不是大神，不是学霸， 我们只是想要走捷径，却必须走过必经之路，才能收获成功果实的普通人。
              </div>
            </b-col>
          </b-row>
          <!-- 咨询列表 -->
          <b-row class="list-content">
            <b-col cols="12" md="5" lg="5" xl="5" class="d1"><img src="https://honeybee-cn.oss-cn-beijing.aliyuncs.com/images/ielts-consulting3.jpg" alt="" /></b-col>
            <b-col cols="12" md="5" lg="7" xl="7" class="d2">
              <div class="listcontent-top">
                <div class="listcontent-left">
                  <img src="../../images/true.png" alt="" />
                  <span>【嗡嗡研究室】考雅思的同学都在关注，就差你了！</span>
                </div>
                <div class="look-detail">
                  <a href="https://mp.weixin.qq.com/s/9_nrCOPMMrxVdudvR3QR2g" target="_blank">
                    <span>查看详情</span>
                    <img src="../../images/backgt.png" alt="" />
                  </a>
                </div>
              </div>
              <div class="l-detail">
                今天给大家总结了一些针对听力Section 2中常出现的Social
                events这一大类的高频必备词汇。各位考鸭要尤其注意，这些高频词汇可能会以填空的形式让你自主填出，也可能会是作为信号词帮你定位答案。Anyway，他们在听力考试中都是超级超级有用哒，所以赶紧学习起来吧！
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'ielts',
  created () {},
  methods: {
    gocoursedetails (type) {
      // 课程详情
      console.log(navigator.userAgent)
      let os = (function () {
        // 判断浏览器性质
        let ua = navigator.userAgent,
          isWindowsPhone = /(?:Windows Phone)/.test(ua),
          isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
          isAndroid = /(?:Android)/.test(ua),
          isFireFox = /(?:Firefox)/.test(ua),
          isChrome = /(?:Chrome|CriOS)/.test(ua),
          isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
          isPhone = /(?:iPhone)/.test(ua) && !isTablet,
          isPc = !isPhone && !isAndroid && !isSymbian
        return {
          isTablet: isTablet,
          isPhone: isPhone,
          isAndroid: isAndroid,
          isPc: isPc
        }
      })()
      /*
				if(os.isAndroid || os.isPhone) { //手机
				  window.location.href="https://app.honeybee-edu.com/h5/pages/contens/index/index?typesting=69";
				} else if(os.isTablet) { //ipad
				  window.location.href="https://app.honeybee-edu.com/h5/pages/contens/index/index?typesting=69";
				} else */
      if (os.isPc) {
        // pc端
        this.$store.commit('change', type)
        sessionStorage.setItem('type', type)
        console.log(sessionStorage.getItem('type'))
        this.$router.push('/coursedetails/coursedetails')
      } else {
        if (type == 0) {
          window.location.href = 'https://app.honeybee-edu.com/h5/pages/contens/index/index?typesting=69'
        } else if (type == 1) {
          window.location.href = 'https://app.honeybee-edu.com/h5/pages/contens/index/index?typesting=ielts_mini_course'
        } else if (type == 2) {
          window.location.href = 'https://app.honeybee-edu.com/h5/pages/contens/index/index?typesting=ielts_class_course'
        } else if (type == 3) {
          window.location.href = 'https://app.honeybee-edu.com/h5/pages/contens/index/index?typesting=ielts_1v1_course'
        }
      }
    }
  }
}
</script>

<style>
.go-detail,
.look-detail {
  cursor: pointer;
}
.l-detail {
  /* 	margin-top: 2.8125rem; */
  font-size: 1rem;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-align: left;
  margin-bottom: 1.25rem;
  color: #999999;
}
.look-detail span {
  font-size: 0.75rem !important;
  font-weight: 400 !important;
}
.look-detail img {
  width: 0.59375rem !important;
  height: 0.59375rem !important;
  margin-left: 0.3125rem;
}
.listcontent-top {
  display: flex;
  justify-content: space-between;
  /* 	margin-top: 1.25rem; */
}
.listcontent-top img {
  width: 1.375rem;
  height: 1.125rem;
}
.listcontent-left {
  max-width: 70%;
}
.listcontent-top span {
  font-size: 1.125rem;
  font-weight: bolder;
  color: #000000;
}
.list-content {
  margin-top: 1.875rem;
  padding-bottom: 1.25rem;
}
.d1,
.d2 {
  width: 100%;
}
.d1 img {
  width: 90%;
  max-height: 15rem;
  margin: 0 auto;
}
.qa {
  width: 4.0625rem;
  height: 4.0625rem;
  border-radius: 50%;
  background-color: #28352c;
  font-size: 1.4375rem;
  font-weight: 400;
  color: #eeeeee;
  line-height: 4.0625rem;
  margin: -2rem auto 0 auto;
}
.consulting-list {
  background-color: #eeeeee;
  position: relative;
}
* {
  font-family: 'pictograph';
}
.alls {
  width: 100%;
  overflow: hidden;
}
.mt-6 {
  margin-top: 3rem !important;
}
.mt-8 {
  margin-top: 5rem !important;
}
.mt-10 {
  margin-top: 7rem !important;
}
.title {
  margin: 0 auto 4.3125rem auto;
  text-align: left;
  display: inline-block;
}
.title-text {
  /* 	font-size: 12px;
	transform: scale(0.7);
	margin-left: -23px; */
  font-size: 0.75rem;
  font-family: FZLanTingHei-DB-GBK;
  color: #28352c;
  transform: scale(0.7);
  margin-left: -1.875rem;
}
.title-name {
  font-weight: bold;
  font-size: 1.5rem;
}
.title-welcome {
  margin-top: 0.625rem;
}
.title-welcome span:nth-child(1) {
  background: #28352c;
  box-shadow: 0.1875rem 0.3125rem 0.5625rem 0.0625rem rgba(0, 0, 0, 0.31);
  border-radius: 0.3125rem;
  color: #ffffff;
  padding: 0.3125rem 0.5625rem;
}
.title-welcome span:nth-child(2) {
  color: #000000;
  font-size: 0.75rem;
  font-weight: bold;
  margin-left: 0.5rem;
}
.subject {
  padding: 0 !important;
  position: relative;
  margin-bottom: 3rem;
}
.subject img {
  width: 100%;
}
.cet-logo {
  position: absolute;
  top: 1rem;
  left: 1rem;
  width: 2.225rem !important;
}
.subject-content {
  position: absolute;
  padding-left: 1.75rem;
  bottom: 0;
  width: 100%;
  text-align: left;
}
.subject-content div:nth-child(1) {
  font-size: 1.2375rem;
  font-weight: 400;
  color: #f2c52d;
}
.subject-content div:nth-child(2) {
  font-size: 1.4375rem;
  font-weight: 400;
  color: #f2c52d;
}
.subject-content div:nth-child(3) {
  font-size: 0.8125rem;
  font-weight: 400;
  color: #f2c52d;
  margin-bottom: 0.8125rem;
}

.subject-price span:nth-child(1) {
  font-size: 1.3125rem;
  font-weight: 400;
  color: #f2c52d;
}
.subject-price span:nth-child(2) {
  font-size: 0.625rem;
  font-weight: 500;
  color: #ffffff;
  text-decoration: line-through;
  margin-left: 2.875rem;
}
.subject-content div:nth-child(5) {
  margin-top: 1rem;
  margin-bottom: 1.6875rem;
  font-size: 0.6875rem;
  font-weight: 400;
  color: #ffffff;
  display: flex;
}

.gt {
  width: 1rem;
  height: 1rem;
  margin-left: 0.95rem;
  display: block;
  text-align: center;
  margin-top: -0.15rem;
}
.gt img {
  width: 100%;
  height: 100%;
}

.consulting {
  margin-top: 0 !important;
}

/* 小屏幕（平板，大于等于 768px） */
@media (min-width: @screen-sm-min) {
  .mt-6 {
    margin-top: 3rem !important;
  }
  .mt-8 {
    margin-top: 5rem !important;
  }
  .mt-10 {
    margin-top: 8rem !important;
  }
  .subject-price span:nth-child(1) {
    font-size: 1.3125rem;
  }
  .subject {
    margin-bottom: 5rem;
  }
  .subject-content {
    padding-left: 3.75rem;
  }

  .subject-price {
    margin-bottom: 3.75rem;
  }

  .subject-price span:nth-child(2) {
    margin-left: 2.875rem;
  }
  .subject-content div:nth-child(5) {
    margin-bottom: 2.6875rem;
  }
}

/* 中等屏幕（桌面显示器，大于等于 992px） */
@media (min-width: @screen-md-min) {
  .mt-6 {
    margin-top: 6rem !important;
  }
  .mt-8 {
    margin-top: 8rem !important;
  }
  .mt-10 {
    margin-top: 10rem !important;
  }
  .subject {
    margin-bottom: 5rem;
  }
  .subject-content {
    padding-left: 3.75rem;
  }

  .subject-price {
    margin-bottom: 3.75rem;
  }

  .subject-price span:nth-child(2) {
    margin-left: 2.875rem;
  }
  .subject-content div:nth-child(5) {
    margin-bottom: 2.6875rem;
  }
}

/* 大屏幕（大桌面显示器，大于等于 1200px） */
@media (min-width: @screen-lg-min) {
  .mt-6 {
    margin-top: 6rem !important;
  }
  .mt-8 {
    margin-top: 8rem !important;
  }
  .mt-10 {
    margin-top: 10rem !important;
  }
  .subject {
    margin-bottom: 5rem;
  }
  .subject-content {
    padding-left: 3.75rem;
  }

  .subject-price {
    margin-bottom: 3.75rem;
  }

  .subject-price span:nth-child(2) {
    margin-left: 2.875rem;
  }
  .subject-content div:nth-child(5) {
    margin-bottom: 2.6875rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ielts/ielts.vue